<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="mx-xs table-preview">
  <p-table
    #dt
    styleClass="card condensed"
    sortField="validTo"
    sortOrder="-1"
    [responsive]="true"
    [columns]="cols"
    [value]="list"
    class="action-list-table condensed table-no-break table-full-width"
    dataKey="uuid"
    [lazy]="true"
    (onLazyLoad)="loadLazy($event)"
    [paginator]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [rows]="10"
    [totalRecords]="totalSize"
    [reorderableColumns]="true" data-testid="uuid-table">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{ col.header | translate }}
          <p-sortIcon field="{{ col.field }}"></p-sortIcon>
        </th>
        <th style="width: 100px"></th>
      </tr>
      <tr>
        <th *ngFor="let col of columns">
          <div class="ui-column-filter">
            <input
              *ngIf="col.type === 'input'"
              pInputText
              placeholder="{{ 'company.subscription-type.actions-list.list.search' | translate }}"
              type="text"
              (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" data-testid="input"/>

            <p-select
              *ngIf="col.type === 'name-dropdown'"
              [style]="{ width: '100%' }"
              [options]="
                actionNameList | formatSelectItemEnum | addEmptySelectItemOption : ('company.utils.all' | translate)
              "
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [ngModel]="selectedName"
              (ngModelChange)="dt.filter($event, col.field, col.filterMatchMode)" data-testid="selected-name-select"></p-select>

            <input
              *ngIf="col.type === 'number'"
              pInputText
              placeholder="{{ 'company.subscription-type.actions-list.list.search' | translate }}"
              type="text"
              (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)" data-testid="input-2"/>

            <p-datePicker
              [readonlyInput]="true"
              *ngIf="col.type === 'calendar'"
              placeholder="{{ 'company.subscription-type.actions-list.list.search' | translate }}"
              appendTo="body"
              dataType="string"
              dateFormat="yy-mm-dd"
              [ngModel]="filterDate"
              (ngModelChange)="dt.filter($event, col.field, col.filterMatchMode)" data-testid="filter-date-datepicker"></p-datePicker>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns">
          <i *ngIf="col.type === 'boolean' && rowData[col.field]" class="ui-icon-check"></i>
          <i *ngIf="col.type === 'boolean' && !rowData[col.field]" class="ui-icon-close"></i>
          <span *ngIf="col.type !== 'boolean'">{{ rowData[col.field] }}</span>
        </td>
        <td *ngIf="isAdministrator === true && rowData.deleted !== true">
          <button class="flat mr-xs" pButton type="button" icon="ui-icon-edit"
                  [disabled]="isExpired(rowData)"
                  (click)="edit(rowData.uuid)" data-testid="edit-btn"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>


